module.exports = __webpack_public_path__ + "img/calender_off.f3a2c8dc.svg";